/* eslint-disable @typescript-eslint/no-explicit-any */
import type { CsvValue } from "./csv-value";

export interface TableColumnOptions {
  right?: true;
  sort?: boolean;
  formatter?: (value: any) => string | number | boolean;
  renderer?: (value: any) => string;
}

interface TableColumnProps {
  key: string;
  title: string;
  options?: TableColumnOptions;
}

export class TableColumn {
  key!: string;
  title!: string;
  options?: TableColumnOptions;

  constructor(props: TableColumnProps) {
    this.key = props.key;
    this.title = props.title;
    this.options = Object.assign({ sort: true }, props.options);
  }

  static for(key: string, title: string, options?: TableColumnOptions) {
    return new TableColumn({
      key,
      title,
      options,
    });
  }

  getCsvValue<T>(value: T): CsvValue {
    const formatter = this.options?.formatter;

    const escape = (value: any) => `"${value}"`;

    return {
      title: this.title,
      value: formatter ? escape(formatter(value)) : escape(value),
    };
  }
}
